import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const layoutStyles = (hasDiscount: boolean) =>
    css({
        display: 'flex',
        width: '100%',
        height: '100%',
        padding: '60px 20px 0 20px',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',
        '::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: hasDiscount ? '307px' : '280px',
            background: isHosTheme ? theme.palette.background.paper : theme.palette.common.black,
            zIndex: -1,
        },
        [theme.breakpoints.up('lg')]: {
            padding: '80px 20px 0 20px',
        },
    });

export const styles = {
    wrapper: css({
        display: 'flex',
        maxWidth: '570px',
        height: '100%',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        rowGap: '40px',
        [theme.breakpoints.up('lg')]: {
            minWidth: '570px',
        },
    }),
    title: css({
        color: theme.palette.common.white,
        marginBottom: '-20px',
    }),
};
